/** Positive recorded lighting evidence; article wording is not product evidence. */
export function hasRecordedLedLighting(product: { features?: unknown }): boolean {
  return Array.isArray(product.features) && product.features.some(feature =>
    typeof feature === 'string' && /\bled\b/i.test(feature) && /\b(?:light|lights|lighting)\b/i.test(feature) &&
    !/\b(?:no|without|not included|does not|non[- ]led)\b/i.test(feature),
  )
}

export function isRefrigeratorLightingArticle(title: string): boolean {
  return /\b(?:fridge|refrigerator|freezer)\b/i.test(title) && /\b(?:light\s*bulbs?|interior\s*light(?:ing)?|led\s*light(?:ing)?)\b/i.test(title)
}

/** Generic article topics cover the whole appliance family, not a legacy type. */
export function articleProductQueryOptions(title: string, detectedType: string): {
  requireStock: true
  requireLedLighting: boolean
  category?: 'refrigerator' | 'freezer'
} {
  return {
    requireStock: true,
    requireLedLighting: isRefrigeratorLightingArticle(title),
    ...(detectedType === 'refrigerator' || detectedType === 'freezer' ? { category: detectedType } : {}),
  }
}
